export default __webpack_public_path__ + "static/Transit-OrientedDevelopmentTODZoning-18f60120272ac3a2d1e997edfdb4bd0c.jpg";